import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import Cookie from 'utils/cookies';
import Link from 'components/Link/Link';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import { loadLoginAboundPoints, handleDataError } from './redux';
import s from './AboundSignup.scss';
import Morebtn from '../../../components_v2/desktop/Morebtn';
import LoaderSpinner from '../LoaderSpinner/LoaderSpinner';

const AboundOTPScreen = ({
  phoneNumber,
  ssoid,
  jssoCrosswalkObj,
  loginUserCallback,
  handleOTPScreen,
  errorConfig,
  countryCode,
  handleShowPopUp,
  loadAboundPoints,
  dataLoading,
  errorMessage,
  userData,
  handleError,
  logout,
}) => {
  const [otp, setOtp] = useState(['', '', '', '', '', '']);
  const [verifySignUpErrorMsg, setVerifySignUpErrorMsg] = useState('');
  const [regenerateOtpSuccess, setRegenerateOtpSuccess] = useState(false);
  const [showCountDownTimer, setShowCountDownTimer] = useState(true);
  const [disableRegenerate, setDisableRegenerate] = useState(false);
  const [countdown, setCountdown] = useState(60);
  const [loader, setLoader] = useState(false);

  const handleChange = (e, index) => {
    const { value } = e.target;
    if (/[^0-9]/.test(value)) return; // Allow only numbers

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
    handleError();

    // Focus the next input if current one is filled
    if (value && index < otp.length - 1) {
      document.getElementById(`otp-input-${index + 1}`).focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace' && !otp[index] && index > 0) {
      // Focus the previous input if backspace is pressed and current input is empty
      document.getElementById(`otp-input-${index - 1}`).focus();
    }
  };

  useEffect(
    () => {
      setVerifySignUpErrorMsg(errorMessage);
    },
    [errorMessage],
  );

  useEffect(
    () => {
      if (
        handleShowPopUp &&
        typeof handleShowPopUp === 'function' &&
        userData?.clientToken
      ) {
        handleShowPopUp(false);
      }
    },
    [userData?.clientToken],
  );

  useEffect(
    () => {
      setLoader(dataLoading);
    },
    [dataLoading],
  );

  const aboundSignUp = () => {
    const ssoId = ssoid || Cookie.get('ssoid') || Cookie.get('ssoId');
    loadAboundPoints({
      ssoid: ssoId,
      phoneNumber,
    });
  };

  const handleSignUpVerifyCallback = response => {
    if (response && response.code === 200) {
      loginUserCallback(false, aboundSignUp);
      window.MobOrEmailloginSuccessful = true;
      window.userPhone = phoneNumber;
      analyticsWrapper('ga4', {
        event: 'user_click',
        type: 'otp_submitted_successfully',
        category: 'abound',
      });
    } else {
      setLoader(false);
      switch (response.code) {
        case 414:
        case 425:
          handleError(errorConfig.wrongOtp);
          break;
        case 415:
          handleError(errorConfig.expiredOTP);
          break;
        case 416:
          handleError(errorConfig.limitExceeded);
          break;
        case 503:
          handleError(errorConfig.connectionError);
          break;
        default:
          handleError(errorConfig.serverError);
      }
    }
  };

  const verifyLoginSignUpOtp = e => {
    e.preventDefault();
    e.stopPropagation();
    const ssoId = ssoid;
    const jssoObj = jssoCrosswalkObj();
    const fnCall = ssoId
      ? jssoObj.verifyMobileSignUp
      : jssoObj.verifyMobileLogin;
    handleError();
    setLoader(true);
    analyticsWrapper('ga4', {
      event: 'user_click',
      type: 'otp_submitted',
      category: 'abound',
    });
    const ssoIdCookie = Cookie.get('ssoid') || Cookie.get('ssoId');
    if (ssoIdCookie) {
      aboundSignUp();
      return;
    }
    if (typeof fnCall === 'function' && ssoId) {
      fnCall.call(
        jssoObj,
        `${countryCode}-${phoneNumber}`,
        ssoId,
        otp.join(''),
        handleSignUpVerifyCallback,
      );
    } else if (typeof fnCall === 'function' && !ssoId) {
      fnCall.call(
        jssoObj,
        `${countryCode}-${phoneNumber}`,
        otp.join(''),
        handleSignUpVerifyCallback,
      );
    }
  };

  const handleRegenerateOTPCallback = response => {
    setLoader(false);
    if (response && response.code === 200) {
      handleError();
      setRegenerateOtpSuccess(true);
    } else {
      switch (response.code) {
        case 416:
          handleError(errorConfig.limitExceeded);
          setRegenerateOtpSuccess(false);
          setDisableRegenerate(true);
          break;
        case 503:
          handleError(errorConfig.connectionError);
          setRegenerateOtpSuccess(false);
          break;
        default:
          handleError(errorConfig.serverError);
          setRegenerateOtpSuccess(false);
      }
    }
  };

  const startTimer = () => {
    setShowCountDownTimer(true);
    const interval = setInterval(() => {
      setCountdown(prevCountdown => {
        if (prevCountdown === 1) {
          clearInterval(interval);
          setShowCountDownTimer(false);
          return 60;
        }
        return prevCountdown - 1;
      });
    }, 1000);
  };

  useEffect(() => {
    startTimer();
  }, []);

  const regenerateOtp = e => {
    e.preventDefault();
    e.stopPropagation();
    if (disableRegenerate || showCountDownTimer) {
      return;
    }
    const jssoObj = jssoCrosswalkObj();
    const fnCall = ssoid
      ? jssoObj.resendMobileSignUpOtp
      : jssoObj.getMobileLoginOtp;
    setRegenerateOtpSuccess(false);
    if (typeof fnCall === 'function' && ssoid) {
      fnCall.call(
        jssoObj,
        `${countryCode}-${phoneNumber}`,
        ssoid,
        handleRegenerateOTPCallback,
      );
    } else if (typeof fnCall === 'function' && !ssoid) {
      fnCall.call(
        jssoObj,
        `${countryCode}-${phoneNumber}`,
        handleRegenerateOTPCallback,
      );
    }
    startTimer();
  };

  return (
    <>
      {loader && <LoaderSpinner />}
      <div className={s.contentHeading}>Verify your Phone Number</div>
      <p className={`${s.paraText} ${s.dark} ${s.noMr}`}>
        Enter the 6 digit code that we sent to
      </p>
      <p className={`${s.paraText} ${s.dark} ${s.editNoRow}`}>
        <span>
          {countryCode}-{phoneNumber}
        </span>{' '}
        <span
          className={s.editBtn}
          onClick={() => {
            handleOTPScreen(false);
            handleError();
            logout();
          }}
        >
          <i />
          Edit
        </span>
      </p>
      <div
        className={`${s.inputWrap} ${s.otpInputWrap} ${
          verifySignUpErrorMsg ? s.error : ''
        }`}
      >
        {otp &&
          Array.isArray(otp) &&
          otp.map((value, index) => (
            <input
              key={index}
              id={`otp-input-${index}`}
              type="tel"
              value={value}
              maxLength="1"
              onChange={e => handleChange(e, index)}
              onKeyDown={e => handleKeyDown(e, index)}
              autoFocus={index === 0}
              className={s.otpValueInput}
              autoComplete="off"
            />
          ))}
        {verifySignUpErrorMsg && (
          <div className={s.errorMsg}>{verifySignUpErrorMsg}</div>
        )}
      </div>
      <p className={s.termAndCondition}>
        By clicking “Continue” below, you agree to Abound’s{' '}
        <Link to="https://accounts.joinabound.com/legal" target="_blank">
          Terms &amp; Conditions
        </Link>{' '}
        and{' '}
        <Link
          to="https://accounts.joinabound.com/legal#section2"
          target="_blank"
        >
          Privacy Policy
        </Link>{' '}
        and{' '}
        <Link
          to="https://accounts.joinabound.com/financialnotice"
          target="_blank"
        >
          Financial Incentive
        </Link>.
      </p>
      <Morebtn
        moreText="Continue"
        redbg
        noArrow
        button
        fullWidth
        onClick={verifyLoginSignUpOtp}
      />
      <div className={s.resendBtnWrap}>
        {/* eslint-disable-next-line react/no-unescaped-entities */}
        <span>Didn't receive OTP?</span>
        <button className={s.resendBtn} onClick={e => regenerateOtp(e)}>
          {!showCountDownTimer ? 'Resend OTP' : `Retry in 00:${countdown}`}
        </button>
      </div>
      {regenerateOtpSuccess && (
        <div className={s.successMsg}>OTP has been successfully sent.</div>
      )}
    </>
  );
};

const mapStateToProps = state => ({
  dataLoading: state?.abound?.dataLoading || false,
  userData: state?.abound?.userData || null,
  errorMessage: state?.abound?.error || null,
});

const mapDispatchToProps = dispatch => ({
  loadAboundPoints: params => {
    dispatch(loadLoginAboundPoints(params));
  },
  handleError: (errorMessage = null) => {
    dispatch(handleDataError(errorMessage));
  },
});
export default connect(mapStateToProps, mapDispatchToProps)(AboundOTPScreen);
